import { IPitchDesignInputs } from 'interfaces/i-pitch-design';

// ? only used for default pitch design inputs
export const STANDARD_PY_FT = 56.5;

export const BS_LIMITS = {
  SPEED_MPH: {
    MIN: 50,
    MAX: 110,
  },
  SPIN_RPM: {
    MIN: -3000,
    MAX: 3000,
  },
  // todo: confirm this shouldn't be over +/-3k
  NET_SPIN_RPM: {
    MIN: -4000,
    MAX: 4000,
  },
  BREAK_IN: {
    MIN: -30,
    MAX: 30,
  },
  GYRO_DEG: {
    MIN: -90,
    MAX: 90,
  },
  AXIS_DEG: {
    MIN: -180,
    MAX: 180,
  },
};

export const DEFAULT_INPUTS: IPitchDesignInputs = {
  speedMph: 60,
  spins: {
    wx: 0,
    wy: 0,
    wz: 0,
  },
  spinExt: {
    wnet: 0,
    gyro_angle: 0,
    waxis: 0,
  },
  breaks: {
    xInches: 0,
    zInches: 0,
  },
  seams: {
    latitude_deg: 0,
    longitude_deg: 0,
  },
  plate: {
    plate_x: 0,
    plate_z: 2.5,
  },
  releasePos: {
    px: 0,
    py: STANDARD_PY_FT,
    pz: 5,
  },
  videoIDs: {
    windupVideoID: null,
    stretchVideoID: null,
  },
};
